export default function Participant(name, role, camera = true, mic = false) {
    this.name = name;
    this.role = role;
    this.mic = mic;
    this.camera = camera;
}